import Base from "@/api-services/base";
import Colaboradores from "@/api-services/colaboradores.service";
import TiposIncidencias from "@/api-services/tiposIncidencias.service";
import moment from "moment";
import {
  IsoDate2Fecha,
  IsoDate2sFechaAmplia,
} from "@/api-services/LiFecha";
import {
  TimeSpan2sHoras,
  TimeSpan2Segundos,
} from "@/api-services/LiTimeSpan";

moment.locale("es-mx");

const BaseURL = `Solicitudes`;

export default {
  GetsResponse: null,
  Listado: [],
  FotoURL(Registro) {
    return "/img/grupos.svg";
  },
  gets(Vista, BaseGetsListado, OnCorrecto, OnErroneo, OnFinalizado) {
    return Base.getsBaseSuscripcion(
      Vista,
      BaseURL,
      BaseGetsListado,
      OnCorrecto,
      OnErroneo,
      OnFinalizado
    );
  },
  GetsColaboradorPrevio(
    Vista,
    BaseGetsListado,
    OnCorrecto,
    OnErroneo,
    OnFinalizado
  ) {
    return Base.getsBaseSuscripcion(
      Vista,
      `${BaseURL}/Colaboradores/Previo`,
      BaseGetsListado,
      OnCorrecto,
      OnErroneo,
      OnFinalizado
    );
  },
  GetsEnriquecido(Vista, BaseGetsListado, OnCorrecto, OnErroneo, OnFinalizado) {
    return Base.getsBaseSuscripcion(
      Vista,
      `${BaseURL}/Enriquecido`,
      BaseGetsListado,
      OnCorrecto,
      OnErroneo,
      OnFinalizado
    );
  },
  GetsTotales(Vista, BaseGetsListado, OnCorrecto, OnErroneo, OnFinalizado) {
    console.debug("GetsTotales");
    return Base.getsBaseSuscripcion(
      Vista,
      `${BaseURL}/Totales`,
      BaseGetsListado,
      OnCorrecto,
      OnErroneo,
      OnFinalizado
    );
  },
  GetsAgrupadas(Vista, BaseGetsListado, OnCorrecto, OnErroneo, OnFinalizado) {
    return Base.getsBaseSuscripcion(
      Vista,
      `${BaseURL}/Agrupadas`,
      BaseGetsListado,
      OnCorrecto,
      OnErroneo,
      OnFinalizado
    );
  },
  getsSelect(Vista, OnCorrecto, OnErroneo, OnFinalizado) {
    if (this.GetsResponse != null) OnCorrecto(this.GetsResponse);
    return Base.getsBaseSuscripcion(
      Vista,
      BaseURL,
      { PaginaLen: 1000 },
      (response) => {
        this.GetsResponse = response;
        this.Listado = response.data.listado;
        if (OnCorrecto != undefined) OnCorrecto(response);
      },
      OnErroneo,
      OnFinalizado
    );
  },
  /**
   * Agrega un comentario a una solicitud
   * @param {*} Vista 
   * @param {*} ID Identificador de la solicitud
   * @param {*} Datos {comentario: "El Comentario Comentario"}
   * @param {*} OnCorrecto 
   * @param {*} OnErroneo 
   * @param {*} OnFinalizado 
   * @returns 
   */
  postComentario(Vista, ID, Datos, OnCorrecto, OnErroneo, OnFinalizado) {
    var URL = Base.ObtenURLSuscripcion(`${BaseURL}/${ID}/Comentarios`);
    return Base.post(Vista, URL, Datos, {}, OnCorrecto, OnErroneo, OnFinalizado);
  },
  put(Vista, ID, Datos, OnCorrecto, OnErroneo, OnFinalizado) {
    var URL = Base.ObtenURLSuscripcion(`${BaseURL}/${ID}`);
    return Base.put(Vista, URL, Datos, {}, OnCorrecto, OnErroneo, OnFinalizado);
  },
  post(Vista, Datos, OnCorrecto, OnErroneo, OnFinalizado) {
    return Base.postBaseSuscripcion(
      Vista,
      BaseURL,
      Datos,
      {},
      OnCorrecto,
      OnErroneo,
      OnFinalizado
    );
  },
  get(Vista, id, OnCorrecto, OnErroneo, OnFinalizado) {
    return Base.getsBaseSuscripcion(
      Vista,
      `${BaseURL}/${id}`,
      {},
      OnCorrecto,
      OnErroneo,
      OnFinalizado
    );
  },
  /**
   * Respuesta detallada para visualización y análisis de contexto de una solicitud.
   * @typedef {Object} SolicitudAvanzadaData
   * @property {Object} solicitud - Datos de la solicitud solicitada.
   * @property {string} solicitud.id - ID de la solicitud (ej. "So.01...").
   * @property {string} solicitud.tipoSolicitud - Tipo de la solicitud (ej. "TiempoXTiempo", "Vacaciones", "TipoIncidencia").
   * @property {string} solicitud.estadoSolicitud - Estado actual (ej. "Desconocido", "Pendiente", "Autorizada", "Denegada").
   * @property {string} solicitud.colaboradorID - ID del colaborador dueño de la solicitud.
   * @property {boolean} solicitud.finalizada - Verdadero si la solicitud finalizó todas sus fases de flujo.
   * @property {Array<string>} solicitud.dias - Fechas involucradas en la solicitud.
   * @property {Array<Object>} solicitud.respuestas - Arreglo con la firma de respuesta de la solicitud (`id`, `fechaHora`, `acepto`, `comentario`).
   * @property {Object|null} cargaTipoIncidencia - Datos adicionales de validación si es TipoIncidencia.
   * @property {Object|null} cargaTiempoExtra - Payload extra si la solicitud es TiempoXTiempo.
   * @property {Object} cargaTiempoExtra.datos - Configuraciones de tiempo extra como `aplicarA` y `regresarDetalle`.
   * @property {Object} cargaTiempoExtra.config - Límites e intervalos para cálculo o proyección interna de horas adicionales.
   * @property {Object|null} cargaCargo - Información respectiva en flujos de nómina (Cargos).
   * @property {Object|null} cargaAumento - Información respectiva de recursos en flujos (Aumentos de Salario).
   * @property {Object} gestion - Detalles de los flujos preconfigurados aplicables a esta gestión.
   * @property {Object} gestion.flujoAsistencias - Parámetros de roles y número de firmas obligatorias.
   * @property {Object} flujo - El estado dinámico de autorizaciones escalonadas (flujo multinivel).
   * @property {boolean} flujo.tieneFlujo - Indica si está configurado en un workflow.
   * @property {boolean} flujo.flujoCompletado - Verdadero si se han otorgado todas las autorizaciones o fue negado ya en definitivo.
   * @property {number} flujo.totalNiveles - Número total de áreas o instancias de autorización, usualmente de 1 a 3.
   * @property {number} flujo.nivelActualIndice - Indica en qué nivel de firma del flujo se ha detenido para autorizar.
   * @property {Array<{indice: number, autorizacionesRequeridas: number, completado: boolean, autorizadores: Array<Object>}>} flujo.niveles - Cada nivel escalonado del motor de fluoj.
   * @property {Array<{colaboradorID: string, estado: string, comentario: string, esSiguienteTurno: boolean}>} flujo.niveles.autorizadores - Propiedades de cada aprobador (`estado` puede ser "Pendiente" o "Espera").
   * @property {Object|null} tipoIncidencia - Objeto origen del catálogo de incidencias referenciado si aplica a justificación.
   * @property {Array<{fecha: string, tipoDiario: string, esFalta: boolean, incompleto: boolean, turnoID: string}>} diarios - Asistencias u omisiones del usuario durante los días que abarca la solicitud.
   * @property {Array<Object>} diasFestivos - Días de asueto o festivos en el rango.
   * @property {Array<{lDias: Array<Object>, color: string, etiqueta: string, preguntaActivo: Object}>} turnos - Catálogo de los modelos de turnos vigentes del colaborador en estos días.
   * @property {Object|null} periodoNomina - Información del periodo fiscal vigente si se cruzara.
   * @property {Array<Object>} solicitudesPendientesColaborador - Histórico de las otras solicitudes activas de este recurso, previendo si hay posibles repeticiones o empalmes.
   * @property {Array<Object>} solicitudesEquipoPeriodo - Histórico de las solicitudes que hicieron otras personas de su mismo equipo (para evitar vaciar puestos u operaciones).
   * @property {number|null} saldoVacaciones - Saldo (En periodos o días netos) que cuenta el empleado a favor de vacaciones.
   * @property {number} txTSaldo - Contenedor base de su Tiempo por Tiempo.
   * @property {number} txTSaldoReal - Saldo TxT Real ya generado o autorizado del trabajador.
   * @property {Object} horasExtrasSemana - Estructura que evalúa si un colaborador rebasó márgenes legales (SueldosTriples) de forma semanalizada.
   * @property {Array<{fecha: string, horasExtras: Object}>} horasExtrasSemana.dias - Días de la semana reportados con sobre-ejecución vs su horario base.
   * @property {Object} estadisticasEquipo - KPIs y contadores gerenciales sumados de los colaboradores.
   * @property {number} estadisticasEquipo.totalSolicitudesPendientes - Cuántos asuntos restan en bandeja del área.
   * @property {number} estadisticasEquipo.txTPendientesMinutos - Estimación base de la deuda en tiempo.
   * @property {Array<{tipoSolicitud: string, pendientes: number, minAutorizados: number}>} estadisticasEquipo.solicitudesPorTipo - Sub-conteo de requerimientos analizado.
   * @property {Array<{id: string, etiqueta: string, urlMiniatura: string, esSolicitante: boolean, departamento: string, puesto: string}>} colaboradores - Directorio o de caché donde pueden buscarse los perfiles del solicitante y aprobadores para mostrar su avatar/puesto sin llamadas extras a API.
   */

  /**
   * Obtiene la información detallada de una solicitud y todo el contexto necesario para autorizarla o denegarla.
   * Ideal para ser utilizada en pantallas de detalle de la solicitud (BandejaFriccionDetalle, etc.).
   * 
   * @param {Object} Vista - Referencia a la vista actual de Vue (ej. `this`).
   * @param {string} id - Identificador de la solicitud que se está abriendo (ej. So.01.XYZ...).
   * @param {function({data: SolicitudAvanzadaData}): void} OnCorrecto - Callback llamado cuando la respuesta es exitosa. La información de respuesta estará parseada según las propiedades descritas en `data`.
   * @param {function(Object): void} [OnErroneo] - Callback de manejo alterno ante error HTTP, o negativa del middleware.
   * @param {function(): void} [OnFinalizado] - Callback final que siempre se ejecuta al cerrar la promesa del servicio o petición de UI, exitosa o con excepción.
   * @returns {Promise} Una promesa del motor de solicitudes web.
   */
  getAvanzado(Vista, id, OnCorrecto, OnErroneo, OnFinalizado) {
    return Base.getsBaseSuscripcion(
      Vista,
      `${BaseURL}/${id}/Avanzado`,
      {},
      OnCorrecto,
      OnErroneo,
      OnFinalizado
    );
  },
  delete(Vista, id, OnCorrecto, OnErroneo, OnFinalizado) {
    return Base.deleteBaseSuscripcion(
      Vista,
      `${BaseURL}/${id}`,
      OnCorrecto,
      OnErroneo,
      OnFinalizado
    );
  },
  EsPendiente(Solicitud) {
    return Solicitud.estadoSolicitud != "Autorizada" && Solicitud.estadoSolicitud != "Denegada";
  },
  GetsExcel(
    Vista,
    BaseGetsListado,
    OnErroneo,
    OnFinalizado
  ) {
    var URL = Base.ObtenURLSuscripcion(`${BaseURL}/Excel`);

    return Base.get(
      Vista,
      URL,
      { responseType: "blob", params: BaseGetsListado },
      (response) => {
        Base.Response2FileDownload(response);
      },
      OnErroneo,
      OnFinalizado
    );
  },

  // ══════════════════════════════════════════════════════════════
  // ── Helpers de Display — funciones puras que reciben solicitud
  // ══════════════════════════════════════════════════════════════

  /**
   * Convierte un color hex/rgb a rgba con alpha.
   * @param {string} color - Color en formato hex o rgb
   * @param {number} alpha - Valor de opacidad (0-1)
   * @returns {string} Color en formato rgba
   */
  ColorConAlpha(color, alpha) {
    if (!color) return "rgba(0,0,0," + alpha + ")";
    if (color.startsWith("rgb")) {
      return color.replace(/rgb\(/, "rgba(").replace(/\)/, "," + alpha + ")");
    }
    var hex = color.replace("#", "");
    if (hex.length === 3) {
      hex = hex[0]+hex[0]+hex[1]+hex[1]+hex[2]+hex[2];
    }
    var r = parseInt(hex.substring(0, 2), 16);
    var g = parseInt(hex.substring(2, 4), 16);
    var b = parseInt(hex.substring(4, 6), 16);
    return "rgba(" + r + "," + g + "," + b + "," + alpha + ")";
  },

  /**
   * Limpia formato "H:MM" → corto.
   * "2:00" → "2h", "-4:00" → "-4h", "1:30" → "1:30h", "0:45" → "0:45h"
   */
  _formatHorasCorta(timeStr) {
    if (!timeStr) return "";
    var neg = timeStr.startsWith("-");
    var clean = neg ? timeStr.substring(1) : timeStr;
    var parts = clean.split(":");
    if (parts.length === 2 && parts[1] === "00") {
      return (neg ? "-" : "") + parts[0] + "h";
    }
    return timeStr + "h";
  },

  /**
   * Etiqueta descriptiva del tipo de solicitud.
   * Detecta TxT consumo/abono, HE, o usa Carga.Etiqueta como fallback.
   */
  EtiquetaTipo(solicitud) {
    if (!solicitud) return "Solicitud";
    if (solicitud.tipoSolicitud === "TiempoXTiempo") {
      try {
        var AplicarA = solicitud.Carga.Datos.AplicarA[0].TxTs;
        var seg = TimeSpan2Segundos(AplicarA.Autorizadas);
        return seg < 0 ? "Consumo TxT" : "Abono TxT";
      } catch (e) { /* fallback */ }
      return "Tiempo X Tiempo";
    }
    if (solicitud.tipoSolicitud === "TiempoExtra") {
      return "Horas Extras";
    }
    if (solicitud.Carga && solicitud.Carga.Etiqueta)
      return solicitud.Carga.Etiqueta;
    return solicitud.tipoSolicitud || "Solicitud";
  },

  /**
   * Tipo legible: mapea tipo técnico a nombre humano.
   * Usa EtiquetaTipo como fallback si no se encuentra en el mapa.
   */
  TipoLegible(solicitud) {
    if (!solicitud) return "Incidencia";
    var tipo = solicitud.tipoSolicitud || "";
    var map = {
      "TiempoExtra": "Tiempo Extra",
      "TiempoXTiempo": "Tiempo por Tiempo",
      "ProyeccionHorasExtras": "Proyección de Horas Extras",
      "Vacaciones": "Vacaciones",
      "Incapacidad": "Incapacidad",
      "PermisoConGoce": "Permiso con Goce",
      "PermisoSinGoce": "Permiso sin Goce",
    };
    return map[tipo] || this.EtiquetaTipo(solicitud);
  },

  /**
   * Clase CSS del ícono según el tipo de solicitud.
   * Maneja TiempoExtra, TiempoXTiempo, ProyeccionHE y delega al catálogo.
   */
  IconoSolicitud(solicitud) {
    if (!solicitud) return "fas fa-file-alt";
    var tipo = solicitud.tipoSolicitud || "";
    if (tipo === "TiempoExtra") return "fas fa-business-time";
    if (tipo === "ProyeccionHorasExtras") return "fas fa-chart-line";
    if (tipo === "TiempoXTiempo") {
      try {
        var val = solicitud.Carga.Datos.AplicarA[0].TxTs.Autorizadas;
        if (typeof val === "string" && val.startsWith("-"))
          return "fas fa-hourglass-end";
      } catch (e) { /* ignorar */ }
      return "fas fa-exchange-alt";
    }
    var tipoObj = {
      etiqueta: this.EtiquetaTipo(solicitud),
      descripcion: tipo,
      abreviatura: (solicitud.Carga && solicitud.Carga.Abreviatura) || "",
    };
    return TiposIncidencias.Icono(tipoObj);
  },

  /**
   * Estado legible. Maneja expiración y "Desconocido" → "Pendiente".
   */
  EstadoTexto(solicitud) {
    if (!solicitud) return "";
    if (solicitud.estadoSolicitud === "Pendiente" && solicitud.fechaExpiracion && moment().isAfter(moment(solicitud.fechaExpiracion))) {
      return "Expirada";
    }
    if (solicitud.estadoSolicitud === "Desconocido")
      return "Pendiente";
    return solicitud.estadoSolicitud || "Pendiente";
  },

  /**
   * Clase CSS del badge de estado (badge-success, badge-danger, etc.).
   */
  BadgeEstadoClass(solicitud) {
    var estado = this.EstadoTexto(solicitud).toLowerCase();
    if (estado === "autorizada") return "badge-success";
    if (estado === "denegada") return "badge-danger";
    if (estado === "parcial") return "badge-warning";
    if (estado === "expirada") return "badge-warning";
    return "badge-info";
  },

  /**
   * Color del tipo de solicitud desde Carga.Color o fallback.
   */
  ColorTipo(solicitud) {
    if (!solicitud) return "var(--info)";
    if (solicitud.Carga && solicitud.Carga.Color) return solicitud.Carga.Color;
    return "var(--info)";
  },

  /**
   * Estilo inline del badge con buen contraste:
   * fondo semi-transparente del color + borde sutil + texto legible.
   */
  BadgeEstilo(solicitud) {
    var color = this.ColorTipo(solicitud);
    if (!color || color === "var(--info)") {
      return {
        backgroundColor: "rgba(17,205,239,0.15)",
        color: "#11cdef",
        border: "1px solid rgba(17,205,239,0.3)",
      };
    }
    if (color.startsWith("var(")) {
      return {
        backgroundColor: color,
        color: "#fff",
        border: "1px solid transparent",
      };
    }
    return {
      backgroundColor: this.ColorConAlpha(color, 0.15),
      color: color,
      border: "1px solid " + this.ColorConAlpha(color, 0.35),
    };
  },

  /**
   * URL de la foto del colaborador.
   */
  FotoColaborador(solicitud) {
    if (!solicitud) return "/img/default-avatar.png";
    if (solicitud.Colaborador && solicitud.Colaborador.urlMiniatura) {
      return solicitud.Colaborador.urlMiniatura.replace("http://", "https://");
    }
    return Colaboradores.FotoURL(solicitud.Colaborador || {});
  },

  /**
   * Nombre del colaborador.
   */
  NombreColaborador(solicitud) {
    if (!solicitud || !solicitud.Colaborador) return "Colaborador";
    return solicitud.Colaborador.etiqueta || "Colaborador";
  },

  /**
   * Puesto del colaborador.
   */
  PuestoColaborador(solicitud) {
    if (!solicitud || !solicitud.Colaborador) return "";
    return solicitud.Colaborador.puesto || solicitud.Colaborador.Puesto || "";
  },

  /**
   * Departamento del colaborador.
   */
  Departamento(solicitud) {
    if (!solicitud || !solicitud.Colaborador) return "";
    return solicitud.Colaborador.departamento
      || solicitud.Colaborador.Departamento
      || "";
  },

  /**
   * Comentarios de la solicitud (incluye caso especial TiempoExtra).
   */
  ComentariosSolicitud(solicitud) {
    if (!solicitud) return "";
    try {
      if (solicitud.tipoSolicitud === "TiempoExtra") {
        var c = solicitud.Carga.Datos.AplicarA[0].Comentarios;
        if (c) return c;
      }
    } catch (e) { /* ignorar */ }
    if (solicitud.Carga && solicitud.Carga.Comentarios)
      return solicitud.Carga.Comentarios;
    return "";
  },

  /**
   * Cantidad descriptiva: "Proyección 5.0 h", "2:30 h", "3 días".
   */
  CantidadTexto(solicitud) {
    if (!solicitud || !solicitud.dias) return "";
    var n = solicitud.dias.length;
    if (n === 0) return "";
    try {
      switch (solicitud.tipoSolicitud) {
        case "ProyeccionHorasExtras": {
          var AplicarA = solicitud.Carga.Datos.AplicarA[0].Proyeccion;
          if (AplicarA.TxT) {
            return "Proyección " + TimeSpan2sHoras(AplicarA.TxT.Autorizadas) + "h";
          } else {
            var NoHoras = 0.0;
            var Config = solicitud.Carga.Config.Proyeccion;
            if (Config.GestionIDSimples) NoHoras += AplicarA.Simples;
            if (Config.GestionIDDobles) NoHoras += AplicarA.Dobles;
            if (Config.GestionIDTriples) NoHoras += AplicarA.Triples;
            return "Proyección " + NoHoras.toFixed(1) + " h";
          }
        }
        case "TiempoExtra": {
          var AplicarA = solicitud.Carga.Datos.AplicarA[0];
          return TimeSpan2sHoras(AplicarA.Autorizadas) + " h";
        }
        case "TiempoXTiempo": {
          var AplicarA = solicitud.Carga.Datos.AplicarA[0].TxTs;
          return TimeSpan2sHoras(AplicarA.Autorizadas) + " h";
        }
      }
    } catch (e) { /* fallback a días */ }
    return n === 1 ? "1 día" : n + " días";
  },

  /**
   * Cantidad ultra-corta para vistazo rápido: "2h", "5d", "+1:30h".
   */
  CantidadCorta(solicitud) {
    if (!solicitud || !solicitud.dias) return "";
    var n = solicitud.dias.length;
    if (n === 0) return "";
    try {
      switch (solicitud.tipoSolicitud) {
        case "ProyeccionHorasExtras": {
          var AplicarA = solicitud.Carga.Datos.AplicarA[0].Proyeccion;
          if (AplicarA.TxT) {
            return this._formatHorasCorta(TimeSpan2sHoras(AplicarA.TxT.Autorizadas));
          } else {
            var NoHoras = 0.0;
            var Config = solicitud.Carga.Config.Proyeccion;
            if (Config.GestionIDSimples) NoHoras += AplicarA.Simples;
            if (Config.GestionIDDobles) NoHoras += AplicarA.Dobles;
            if (Config.GestionIDTriples) NoHoras += AplicarA.Triples;
            var rounded = Math.round(NoHoras * 10) / 10;
            return (rounded % 1 === 0 ? rounded.toFixed(0) : rounded.toFixed(1)) + "h";
          }
        }
        case "TiempoExtra": {
          var AplicarA = solicitud.Carga.Datos.AplicarA[0];
          if (AplicarA.TxT) return this._formatHorasCorta(TimeSpan2sHoras(AplicarA.Autorizadas));
          return this._formatHorasCorta(TimeSpan2sHoras(AplicarA.Autorizadas));
        }
        case "TiempoXTiempo": {
          var AplicarA = solicitud.Carga.Datos.AplicarA[0].TxTs;
          var seg = TimeSpan2Segundos(AplicarA.Autorizadas);
          var label = seg < 0 ? "-" : "+";
          return label + " " + this._formatHorasCorta(TimeSpan2sHoras(AplicarA.Autorizadas, true));
        }
      }
    } catch (e) { /* fallback */ }
    return n + "d";
  },

  /**
   * Tooltip descriptivo de la cantidad.
   */
  CantidadTooltip(solicitud) {
    if (!solicitud || !solicitud.dias) return "";
    var n = solicitud.dias.length;
    if (n === 0) return "";
    try {
      switch (solicitud.tipoSolicitud) {
        case "ProyeccionHorasExtras": {
          var AplicarA = solicitud.Carga.Datos.AplicarA[0].Proyeccion;
          if (AplicarA.TxT) {
            return TimeSpan2sHoras(AplicarA.TxT.Autorizadas) + " Horas";
          } else {
            var NoHoras = 0.0;
            var Config = solicitud.Carga.Config.Proyeccion;
            if (Config.GestionIDSimples) NoHoras += AplicarA.Simples;
            if (Config.GestionIDDobles) NoHoras += AplicarA.Dobles;
            if (Config.GestionIDTriples) NoHoras += AplicarA.Triples;
            var rounded = Math.round(NoHoras * 10) / 10;
            return (rounded % 1 === 0 ? rounded.toFixed(0) : rounded.toFixed(1)) + " Horas";
          }
        }
        case "TiempoExtra": {
          var AplicarA = solicitud.Carga.Datos.AplicarA[0];
          return TimeSpan2sHoras(AplicarA.Autorizadas) + " Horas";
        }
        case "TiempoXTiempo": {
          var AplicarA = solicitud.Carga.Datos.AplicarA[0].TxTs;
          var seg = TimeSpan2Segundos(AplicarA.Autorizadas);
          var label = seg < 0 ? "Consumo" : "Abono";
          return label + " " + TimeSpan2sHoras(AplicarA.Autorizadas, true) + " Horas";
        }
      }
    } catch (e) { /* fallback */ }
    return n === 1 ? "1 Día" : n + " Días";
  },

  /**
   * Formato de días legible (detecta consecutivos vs sueltos).
   * - 1 día: "Lun, 02/Mar/26"
   * - Consecutivos: "Lun 02 → Mié 04/Mar/26"
   * - No consecutivos: "Lun 02/Mar, Mié 04/Mar, Vie 06/Mar"
   */
  FormatoDias(solicitud) {
    if (!solicitud || !solicitud.dias || solicitud.dias.length === 0) {
      if (!solicitud || !solicitud.diaMinimo) return "";
      return IsoDate2sFechaAmplia(IsoDate2Fecha(solicitud.diaMinimo));
    }
    var dias = solicitud.dias
      .map(function(d) { return moment(typeof d === "string" ? d.substring(0, 10) : d); })
      .filter(function(m) { return m.isValid(); })
      .sort(function(a, b) { return a.valueOf() - b.valueOf(); });
    if (dias.length === 0) return "";
    if (dias.length === 1) return dias[0].format("ddd, DD/MMM/YY");

    // Detectar si son consecutivos
    var consecutivos = true;
    for (var i = 1; i < dias.length; i++) {
      if (dias[i].diff(dias[i - 1], "days") !== 1) {
        consecutivos = false;
        break;
      }
    }
    if (consecutivos) {
      var inicio = dias[0];
      var fin = dias[dias.length - 1];
      if (inicio.month() === fin.month() && inicio.year() === fin.year()) {
        return inicio.format("ddd DD") + " → " + fin.format("ddd DD/MMM/YY");
      }
      return inicio.format("ddd DD/MMM") + " → " + fin.format("ddd DD/MMM/YY");
    }
    // No consecutivos: listar cada fecha
    if (dias.length <= 4) {
      return dias.map(function(d) { return d.format("ddd DD/MMM"); }).join(", ");
    }
    return dias[0].format("ddd DD/MMM") + ", " + dias[1].format("ddd DD/MMM") + " … " + dias[dias.length - 1].format("ddd DD/MMM/YY");
  },

  /**
   * Versión corta del formato de días: "DD - DD MMM" o "DD/MMM - DD/MMM".
   */
  FormatoDiasCorto(solicitud) {
    if (!solicitud || !solicitud.dias || solicitud.dias.length === 0) {
      if (!solicitud || !solicitud.diaMinimo) return "";
      return moment(solicitud.diaMinimo).format("ddd, DD/MMM/YY");
    }
    var dias = solicitud.dias
      .map(function(d) { return moment(typeof d === "string" ? d.substring(0, 10) : d); })
      .filter(function(m) { return m.isValid(); })
      .sort(function(a, b) { return a.valueOf() - b.valueOf(); });
    if (dias.length === 0) return "";
    if (dias.length === 1) return dias[0].format("ddd DD/MMM");
    var inicio = dias[0];
    var fin = dias[dias.length - 1];
    if (inicio.month() === fin.month()) {
      return inicio.format("DD") + " - " + fin.format("DD MMM");
    }
    return inicio.format("DD/MMM") + " - " + fin.format("DD/MMM");
  },

  /**
   * Fecha de referencia (primer día) como objeto moment.
   */
  FechaReferencia(solicitud) {
    if (!solicitud) return null;
    var dias = [];
    if (solicitud.dias && solicitud.dias.length > 0) {
      dias = solicitud.dias
        .map(function(d) { return moment(typeof d === "string" ? d.substring(0, 10) : d); })
        .filter(function(m) { return m.isValid(); })
        .sort(function(a, b) { return a.valueOf() - b.valueOf(); });
    }
    if (dias.length > 0) return dias[0];
    if (solicitud.diaMinimo) {
      var m = moment(solicitud.diaMinimo);
      if (m.isValid()) return m;
    }
    return null;
  },

  /**
   * Texto de tiempo relativo rico: "Hoy", "Mañana", "El próximo Lunes", etc.
   */
  TextoTiempoRelativo(solicitud) {
    var fechaRef = this.FechaReferencia(solicitud);
    if (!fechaRef) return "";
    var hoy = moment().startOf("day");
    var fecha = fechaRef.clone().startOf("day");
    var diff = fecha.diff(hoy, "days");

    if (diff === 0) return "Hoy";
    if (diff === 1) return "Mañana";
    if (diff === -1) return "Ayer";
    if (diff === 2) return "Pasado mañana";
    if (diff === -2) return "Antier";

    if (diff >= 3 && diff <= 6) {
      var diaSemana = fecha.format("dddd");
      return "El próximo " + diaSemana.charAt(0).toUpperCase() + diaSemana.slice(1);
    }
    if (diff <= -3 && diff >= -6) {
      var diaSemana2 = fecha.format("dddd");
      return "El " + diaSemana2.charAt(0).toUpperCase() + diaSemana2.slice(1) + " pasado";
    }

    if (diff > 6) {
      if (diff <= 30) return "En " + diff + " días";
      if (diff <= 60) return "En ~" + Math.round(diff / 7) + " semanas";
      return "En " + Math.round(diff / 30) + " meses";
    }
    if (diff < -6) {
      var absDiff = Math.abs(diff);
      if (absDiff <= 30) return "Hace " + absDiff + " días";
      if (absDiff <= 60) return "Hace ~" + Math.round(absDiff / 7) + " semanas";
      return "Hace " + Math.round(absDiff / 30) + " meses";
    }
    return "";
  },

  /**
   * Clase CSS de urgencia (7 niveles) según distancia temporal.
   */
  ClaseUrgencia(solicitud) {
    var fechaRef = this.FechaReferencia(solicitud);
    if (!fechaRef) return "";
    var hoy = moment().startOf("day");
    var fecha = fechaRef.clone().startOf("day");
    var diff = fecha.diff(hoy, "days");

    if (diff < -7) return "urgencia-critica";
    if (diff < -2) return "urgencia-alta";
    if (diff < 0)  return "urgencia-media-alta";
    if (diff === 0) return "urgencia-media";
    if (diff === 1) return "urgencia-media-baja";
    if (diff <= 3)  return "urgencia-baja";
    return "urgencia-tranquila";
  },

  /**
   * Color CSS de urgencia para bordes/indicadores: var(--danger/warning/success/secondary).
   */
  ColorUrgencia(solicitud) {
    if (!solicitud || !solicitud.diaMinimo) return "var(--secondary)";
    var dias = moment(solicitud.diaMinimo).diff(moment().startOf("day"), "days");
    if (dias < 0) return "var(--danger)";
    if (dias <= 3) return "var(--warning)";
    return "var(--success)";
  },

  /**
   * "TxT: 2:30 horas" cuando TiempoExtra es realmente TxT.
   */
  EtiquetaTxTEnHE(solicitud) {
    if (!solicitud || solicitud.tipoSolicitud !== "TiempoExtra") return "";
    try {
      var AplicarA = solicitud.Carga.Datos.AplicarA[0];
      if (AplicarA.TxT) return "TxT: " + TimeSpan2sHoras(AplicarA.Autorizadas) + " horas";
    } catch (e) { /* ignorar */ }
    return "";
  },

  /**
   * "Consumo de TxT" / "Abono de TxT".
   */
  EtiquetaTxTConsumoAbono(solicitud) {
    if (!solicitud || solicitud.tipoSolicitud !== "TiempoXTiempo") return "";
    try {
      var AplicarA = solicitud.Carga.Datos.AplicarA[0].TxTs;
      var seg = TimeSpan2Segundos(AplicarA.Autorizadas);
      return seg < 0 ? "Consumo de TxT" : "Abono de TxT";
    } catch (e) { /* ignorar */ }
    return "";
  },
};
